export const CREATE_CLIENT_PAGE = 'CREATE_CLIENT_PAGE';
export const CREATE_CLIENT_BY_LINK_PAGE = 'CREATE_CLIENT_BY_LINK_PAGE';
export const CREATE_CLIENT_LOADER_PAGE = 'CREATE_CLIENT_LOADER_PAGE';
